// src/components/RaffleCountdownPopup.jsx
import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './RaffleCountdownPopup.css';

const RaffleCountdownPopup = ({ event, onClose, onPurchase }) => {
    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        total: 0
    });
    const [show, setShow] = useState(true);

    useEffect(() => {
        const updateTimer = () => {
            if (!event?.draw_date) return;
            
            const targetDate = new Date(event.draw_date);
            const now = new Date();
            const diff = targetDate - now;
            
            if (diff <= 0) {
                setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0, total: 0 });
                return;
            }
            
            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);
            
            setTimeLeft({ days, hours, minutes, seconds, total: diff });
        };
        
        updateTimer();
        const interval = setInterval(updateTimer, 1000);
        return () => clearInterval(interval);
    }, [event]);

    // Auto hide popup after 10 seconds if not interacted
    useEffect(() => {
        const timeout = setTimeout(() => {
            setShow(false);
            if (onClose) onClose();
        }, 10000);
        
        return () => clearTimeout(timeout);
    }, [onClose]);

    if (!show || !event || timeLeft.total <= 0) return null;

    return (
        <AnimatePresence>
            <motion.div 
                className="raffle-popup-overlay"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >
                <motion.div 
                    className="raffle-popup"
                    initial={{ scale: 0.8, opacity: 0, y: 50 }}
                    animate={{ scale: 1, opacity: 1, y: 0 }}
                    exit={{ scale: 0.8, opacity: 0, y: 50 }}
                    transition={{ type: "spring", damping: 20 }}
                >
                    <button className="popup-close" onClick={() => {
                        setShow(false);
                        if (onClose) onClose();
                    }}>
                        <i className="fa-solid fa-times"></i>
                    </button>
                    
                    <div className="popup-header">
                        <div className="popup-icon">
                            <i className="fa-solid fa-gift"></i>
                        </div>
                        <h3>🎉 Raffle Draw Alert!</h3>
                    </div>
                    
                    <div className="popup-content">
                        <h4>{event.title}</h4>
                        <p>Don't miss your chance to win amazing prizes!</p>
                        
                        <div className="popup-countdown">
                            <div className="countdown-block">
                                <span className="countdown-number">{timeLeft.days}</span>
                                <span className="countdown-label">Days</span>
                            </div>
                            <div className="countdown-block">
                                <span className="countdown-number">{timeLeft.hours}</span>
                                <span className="countdown-label">Hours</span>
                            </div>
                            <div className="countdown-block">
                                <span className="countdown-number">{timeLeft.minutes}</span>
                                <span className="countdown-label">Mins</span>
                            </div>
                            <div className="countdown-block">
                                <span className="countdown-number">{timeLeft.seconds}</span>
                                <span className="countdown-label">Secs</span>
                            </div>
                        </div>
                        
                        <div className="prize-preview">
                            <i className="fa-solid fa-trophy"></i>
                            <span>{event.total_prizes || 'Multiple'} Prizes to be won!</span>
                        </div>
                        
                        <div className="ticket-info">
                            <i className="fa-solid fa-ticket"></i>
                            <span>₦{Number(event.ticket_price).toLocaleString()} per ticket</span>
                        </div>
                    </div>
                    
                    <div className="popup-actions">
                        <button 
                            className="btn-buy"
                            onClick={() => {
                                setShow(false);
                                if (onPurchase) onPurchase(event);
                            }}
                        >
                            <i className="fa-solid fa-ticket"></i>
                            Buy Tickets Now
                        </button>
                        <button 
                            className="btn-later"
                            onClick={() => {
                                setShow(false);
                                if (onClose) onClose();
                            }}
                        >
                            Remind Me Later
                        </button>
                    </div>
                </motion.div>
            </motion.div>
        </AnimatePresence>
    );
};

export default RaffleCountdownPopup;